import {
  ADD_WORKSPACE,
  REMOVE_WORKSPACE,
  SET_ACTIVE_WORKSPACE,
  SET_WORKSPACE_DATA,
  UPDATE_WORKSPACE,
  REARRANGE_WORKSPACE,
  LAUNCH_APP,
  SET_CURRENT_APP,
  SET_LAUNCHING_WORKSPACE
} from '../types/workspaceConstants'

export function addWorkspace(item) {
  return {
    type: ADD_WORKSPACE,
    payload: item
  }
}
export function updateWorkspace(item) {
  return {
    type: UPDATE_WORKSPACE,
    payload: item
  }
}

export function removeWorkspace(item) {
  return {
    type: REMOVE_WORKSPACE,
    payload: item
  }
}

export function setActiveWorkspace(item) {
  return {
    type: SET_ACTIVE_WORKSPACE,
    payload: item
  }
}

export function rearrangeWorkspace(item) {
  return {
    type: REARRANGE_WORKSPACE,
    payload: item
  }
}

export function launchApp(app) {
  return {
    type: LAUNCH_APP,
    payload: app
  }
}

export function setWorkspaceData(item) {
  return {
    type: SET_WORKSPACE_DATA,
    payload: item
  }
}

export function setCurrentApp(app) {
  return {
    type: SET_CURRENT_APP,
    payload: app
  }
}

export function setLaunchingWorkspace(id) {
  return {
    type: SET_LAUNCHING_WORKSPACE,
    payload: id
  }
}
